import React, { Component } from 'react';
import { connect } from "react-redux";
import { Field, FieldArray, reduxForm, initialize } from 'redux-form';
import { updateCompany } from '../../redux/actions';

import { toArray } from "../assets/util";
import { ShortField, Shortcuts } from '../atoms/formElements/formElements';
import Button from '../atoms/button/button';
import SideModal from '../molecules/modal/sideModal';

class Settings extends Component {
  render() {
    const { state, initialValues, handleSubmit } = this.props;
    return (
      <SideModal active={state ? 'active' : null } screen='settings' >
        <div id='sideModalWrapper'>
          <h1>Company settings</h1>
          <form model="initialValues">
            {/* logo */}
            <Field name='tagline' label='Company tagline' component={ShortField} type='text' />
            <div className='shortcutsList'>
              <label className='shortcutheader'>Company shortcuts</label>
              <p className='small'>These shortcuts will be available for new employees!</p>
              <FieldArray name='shortcuts' component={Shortcuts}/>
            </div>
            <Button label='Save' disabled='false' type='button' onClick={handleSubmit(values => this.props.updateCompany(values))} />
          </form>
        </div>
      </SideModal>
    )
  }
}

const validate = values => { //validate function will automatically be called by redux-form
  const errors = {};
  if(!values.tagline) { errors.tagline = 'Required' }
  if(values.shortcuts && values.shortcuts.length > 5) {
    errors.shortcuts = 'Max 5 shortcuts allowed'
  }
  return errors;
}

function mapStateToProps(state) {
  let companyShortcuts = null;
  if(state.firestore && state.firestore.data && state.firestore.data.customers && state.firestore.data.customers[state.general.company.customerId]) {
    companyShortcuts = state.firestore.data.customers[state.general.company.customerId].companyShortcuts
  }
  return {
    state: state.overlays.settings,
    initialValues: {
      tagline: state.firestore.data.customers[state.general.company.customerId].tagline,
      shortcuts: toArray(companyShortcuts)
    },
  };

}

let InitializeFromStateForm = reduxForm({
  form: 'companyForm',
  enableReinitialize : true,
  validate
})(Settings)


// You have to connect() to any reducers that you wish to connect to yourself
export default connect(mapStateToProps, { updateCompany })(InitializeFromStateForm)
